import { FormConfig } from '@shared/interfaces/form-configs/form-config';
import {
  CreateMeteringPointCommand,
  MeteringPointSubType,
  MeteringPointType, MeterReadingType,
  ObservationTimeSeriesPeriod,
  ProductCharacteristicIdentification,
  ProductCharacteristicUnitType
} from '@app/api/dmc';

export const meteringPointTypeTemplateConsumptionFromGridQuarterlyFormConfig: FormConfig<CreateMeteringPointCommand> = {
  'detailCharacteristics.meteringPointType': {
    value: MeteringPointType.ConsumptionFromGrid,
  },
  'detailCharacteristics.subType': {
    value: MeteringPointSubType.Physical,
  },
  'detailCharacteristics.productCharacteristicIdentification': {
    value: ProductCharacteristicIdentification.EnergyActive,
    state: 'required',
  },
  'detailCharacteristics.productCharacteristicUnitType': {
    value: ProductCharacteristicUnitType.KWH,
    state: 'required',
  },
  'detailCharacteristics.fromGridAreaId': {
    state: 'disabled',
  },
  'detailCharacteristics.toGridAreaId': {
    state: 'disabled',
  },
  'detailCharacteristics.meterReadingOccurrence': {
    state: 'required',
    value: ObservationTimeSeriesPeriod.Quarter,
  },
  'detailCharacteristics.capacity': {
    state: 'optional',
  },
  'detailCharacteristics.assetType': {
    state: 'optional',
  },
  'detailCharacteristics.powerPlantIdentification': {
    state: 'optional',
  },
  'connectionPointId': {
    state: 'optional',
  },
  'detailMeterCharacteristic.numberOfDigits': {
    state: 'optional',
    value: "7"
  },
  'detailMeterCharacteristic.unitType': {
    state: 'optional',
    value: ProductCharacteristicUnitType.KWH
  },
  'detailMeterCharacteristic.meterReadingType': {
    state: 'optional',
    value: MeterReadingType.Accumulated
  },
  // TS-Ignore necessary to reference a field that doesn't exist.
  // @ts-expect-error TS2353: extra property
  'connectionPointIdentification': {
    state: 'optional',
    optional: true,
  },
  'connectionPointAddress': {
    state: 'optional',
    optional: true,
  }
}
